import styled, { css } from "styled-components";
import { Form } from "formik";

import { rem } from "@ui/helpers";
import { Button } from "@ui/Atoms/Button";

const ZipForm = styled(Form)`
  display: inline-flex;
  flex-direction: column;
  width: 100%;
`;

const FormContent = styled.div<{ isHorizontal?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.margins.base};

  ${props =>
    props.isHorizontal &&
    css`
      flex-direction: row;
    `}

  ${props => props.theme.breakpoints.tablet} {
    flex-direction: row;
    gap: ${props => props.theme.margins.base_x3};
  }

  .select-extended {
    width: 100%;
    min-width: ${rem(234)};

    ${props =>
      props.isHorizontal &&
      css`
        min-width: ${rem(192)};
      `}
  }
`;

const SelectWrapper = styled.div`
  width: 100%;

  ${props => props.theme.breakpoints.tablet} {
    min-width: ${rem(234)};

    .input-with-error {
      position: absolute;
      width: auto;
    }
  }
`;

const SubmitButton = styled(Button)<{
  isHorizontal?: boolean;
  fitContent?: boolean;
}>`
  max-height: ${rem(3.5)};
  width: 100%;

  ${props =>
    props.isHorizontal &&
    css`
      width: ${props.theme.buttons.sizes.medium};
    `}

  ${props => props.theme.breakpoints.tablet} {
    width: ${props => props.theme.buttons.sizes.medium};
  }

  ${props =>
    props.fitContent &&
    css`
      width: auto;
      box-sizing: border-box;
      flex: 0 0 fit-content;
    `}
`;

const InputWrapper = styled.div`
  min-width: ${rem(234)};

  input::placeholder {
    font-size: ${props => props.theme.fonts.sizes.body};
  }
`;

const HiddenInput = styled.input`
  visibility: hidden;
  position: absolute;
`;

export {
  ZipForm,
  FormContent,
  SelectWrapper,
  SubmitButton,
  InputWrapper,
  HiddenInput,
};
